import { render } from "./XIconSolidReceipt.vue?vue&type=template&id=2c6845f4"
import script from "./XIconSolidReceipt.vue?vue&type=script&lang=js"
export * from "./XIconSolidReceipt.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidReceipt.vue"]])

export default __exports__